import { render } from "./IntegrationSerieSkeleton.vue?vue&type=template&id=3fcbe730"
import script from "./IntegrationSerieSkeleton.vue?vue&type=script&lang=js"
export * from "./IntegrationSerieSkeleton.vue?vue&type=script&lang=js"

import "./IntegrationSerieSkeleton.vue?vue&type=style&index=0&id=3fcbe730&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__